import { observer } from 'mobx-react-lite';
import * as React from 'react';

import './yearly-fees.css';

import { AmountInput } from '../components/amount-input';
import { IAmount, Store } from '../stores/store';
import { formatAmount } from '../utils/amounts';

interface IProps {
    store: Store;
}

export const YearlyFeesSection = observer<IProps>(({ store }) => {
    const onOpenAccount = React.useCallback(() => {
        const path = `https://portal.payhawk.com/auth/signup?utm_source=hackathon&utm_medium=website&utm_campaign=currency_calculator`;
        if (window.parent) {
            window.parent.location.href = path;
        } else {
            window.location.href = path;
        }
    }, []);

    const onYearlyAmountChange = React.useCallback((amount: IAmount) => {
        store.setYearlyBudget({ currency: amount.currency, value: amount.value || 0 });
    }, [store]);

    return (
        <div>
            <p className='big'>
                Enter your yearly spend on international transactions to calculate your estimated charges on foreign exchange rates.
            </p>
            <div className='yearly-fees'>
                <AmountInput amount={store.yearlyBudget} onAmountChanged={onYearlyAmountChange} readonly />
            </div>
            {store.estimatedBankFees > store.estimatedPayhawkFees ?
                (<div style={{ paddingBottom: '10px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', paddingBottom: '10px' }} >
                        <div style={{ marginLeft: '10%', textAlign: 'center' }} >
                            <div style={{ fontWeight: 'bold' }}>Payhawk card fees:</div>
                            <div>{formatAmount(store.estimatedPayhawkYearlyFees, store.bankChargeAmount.currency)}</div>
                        </div>
                        <div style={{ marginRight: '10%', textAlign: 'center' }}>
                            <div style={{ fontWeight: 'bold' }}>Your card fees:</div>
                            <div>{formatAmount(store.estimatedBankYearlyFees, store.bankChargeAmount.currency)}</div>
                        </div>
                    </div>

                    <progress max={store.estimatedBankFees} value={store.estimatedPayhawkFees} style={{ display: 'block', margin: 'auto', width: '85%' }} />
                </div>) : (

                    <div style={{ textAlign: 'center', marginBottom: '8px' }}>
                        <div style={{ fontWeight: 'bold' }}>Your card fees:</div>
                        <div>{formatAmount(store.estimatedBankYearlyFees, store.bankChargeAmount.currency)}</div>
                    </div>
                )

            }

            <div className='btn-wrapper'>
                <button type='button' className='btn' onClick={store.goBack}>Back</button>
                <button type='button' className='btn btn-green' onClick={onOpenAccount}>Open account</button>
            </div>
        </div>
    );
});
